<template>
    <div class="onboarding obd-welcome all-center">
        <div>
            <img class="obd-welcome__logo" src="@/assets/logo.svg" alt="Swift">

            <div class="obd-welcome__img-content">
                <img src="../assets/img-welcome.svg" alt="image-welcome" />
            </div>

            <div class="obd-welcome__content">
                <h1 class="primary-color">Welcome to Swift</h1>
                <p class="m-b-16">All of the speed optimization you need in one place, from optimizing images to optimizing themes and especially optimizing user perception about speed. Let's explore.</p>

                <!-- Màn hình khi user chỉ mua mỗi plan Percieved Speed  -->
                <template v-if="store.app_plan == 'perceived'">
                    <div>
                        <a-button type="primary" @click="goToDashboard">Start now</a-button>
                    </div>
                </template>
                <!-- Màn hình khi mua plan actual speed, full plan -->
                <template v-else>
                    <div>
                        <!-- <a-button type="default" @click="goToDashboard">I want explore myself</a-button>
                        <a-button type="primary" class="m-l-8" @click="goActualSpeed">Explore with us</a-button> -->
                        <a-button type="primary" @click="goToDashboard">Explore Now</a-button>
                    </div>
                </template>
            </div>
        </div>
    <vue-modal-redirect v-model="modalRedirect"></vue-modal-redirect>
    </div>
</template>
<script>
import cookie from 'js-cookie'
import { types as typesAuth } from "@/modules/auth/constant"
import { types as typesOnboarding } from './../constant'

import { mapGetters, mapActions, mapMutations } from "vuex";

import routerName from '@/constants/routers'

export default {
    name: "OnboardWelcome",
    metaInfo: {
        title: "Welcome"
    },
    components: {},
    data() {
        return {
            modalRedirect: {
                isVisible: false
            },
        };
    },
    computed: {
		...mapGetters({
            store: typesAuth.getters.GET_STORE
		})
	},
    created() {
    },
    methods: {
        ...mapActions({
            onboardingDone: typesOnboarding.actions.ONBOARDING_DONE
        }),
        ...mapMutations({
            setStore: typesAuth.mutations.SET_STORE
		}),

        goToDashboard() {
            let showTooltip = {}
            if (this.store.app_plan == 'perceived') {
                showTooltip = {
                    perceived: {
                        isShowedTTPerceived: false,
                        isShowedTTPreloading: false,
                        isShowedTTLoading: false,
                        showTTPerceived: true,
                        showTTPreloading: false,
                        showTTLoading: false
                    }
                }
            } else if (this.store.app_plan == 'actual')  {
                showTooltip = {
                    perceived: {
                        isShowedTTPerceived: false,
                        showTTPerceived: false,
                    },
                    actual: {
                        isShowedTTActual: false,
                        showTTActual: true,
                    }
                }
            } else {
                showTooltip = {
                    perceived: {
                        isShowedTTPerceived: false,
                        isShowedTTPreloading: false,
                        isShowedTTLoading: false,
                        showTTPerceived: false,
                        showTTPreloading: false,
                        showTTLoading: false
                    },
                    actual: {
                        isShowedTTActual: false,
                        showTTActual: true,
                    }
                }
            }

            cookie.set('show-tooltip', showTooltip, { expires: 1 })

            this.modalRedirect.isVisible = true;
            this.apiObdDone();

            let objStore = JSON.parse(JSON.stringify(this.store))
            objStore['onboarding_required'] = 0
            this.setStore(objStore)

            setTimeout(()=> {
                this.modalRedirect.isVisible = false;
                this.$router.push({
                    name: routerName.DASHBOARD
                })
            }, 2000)
        },

        goActualSpeed() {
            this.$router.push({
                name: routerName.ONBOARD_SET_UP
            })
        },

        async apiObdDone() {
            let self = this
            await this.onboardingDone().then(res => {
                let { status = false, data = [] } = res.data
                if (!status) {
                    self.toastError({
                        title: "Error",
                        message: self.$t('app.errors.something_went_wrong'),
                        duration: 4
                    })
                }
            }).catch(e => {
                console.log(e);
            });
        },
    }
};
</script>

<style lang="scss">
    .onboarding {
        height: 100vh;
        .obd-welcome {
            text-align: center;
            &__logo {
                height: 60px;
                width: auto;
                margin-bottom: 34px;
            }
            &__img-content {
                img {
                    width: auto;
                    height: 265px;
                }
                margin-bottom: 24px;
            }
            &__content {
                h1 {
                    font-size: 1.875rem;
                }
                p {
                    color: $text-color-secondary;
                    margin: auto;
                    max-width: 730px;
                }
            }
        }
    }
</style>
